/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

export const FlagsPermissionDashboard = {
  dashboard_enable: new Rox.Flag(false)
};

export const FcsPermissionDashboard = {
  permission_tab_leaderboard_enable: new FcsFlag.Flag(false),
  config_leaderboard_po_operational_hours: new FcsFlag.StringFlag("08:00-22:00")
}

export function initFlagsPermissionDashboard() {
  // register flags with namespaces for better grouping
  Rox.register("featureDashboard", FlagsPermissionDashboard);
  FcsFlag.register("featureDashboard", FcsPermissionDashboard);
}